function formatDate(date) {
    if (!date) return null;
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
}
function unformatDate(date) {
    if (!date) return null;
    const [day, month, year] = date.split("-");
    return `${year}-${month}-${day}`;
}
function registrationStatus(item) {
    const start = new Date(`${formatDate(item.arrival_date_from)}T00:00:00`);
    const end = new Date(`${formatDate(item.arrival_date_to)}T23:59:59`);
    const today = new Date();
    const diffStart = start.getTime() <= today.getTime();
    const diffEnd = today.getTime() < end.getTime();
    if (!diffEnd) return "1 expired";
    if (diffStart && diffEnd) return "2 today";
    return "3 future";
}
export { formatDate, unformatDate, registrationStatus };
